<template>
  <div>
    <div class="popupDefinitionFreeMessage xx" v-if="popupShow" :style="{ zIndex: popupIndex ? 99999 : 99998 }">
      <div class="maskWin"></div>
      <div class="popupDefinitionAll" :style="{ width: fieldval.width + '%', height: fieldval.height + '%' }">
        <div class="popupDefinitionHeadline">
          <div style="padding-left: 20px">{{ fieldval.name }}</div>
          <div @click="getClose('关闭')" v-if="fieldval.buttonClose == '1'" style="cursor: pointer">
            <img class="popupDefinitionHeadlineClosebannerImg" src="https://imagecdn.ymm56.com/ymmfile/static/resource/79787d2b-21f5-45c0-ae79-be3d7fcbddd8.png" alt="" />
          </div>
        </div>
        <div class="perpetualClose" @click="getClose('不再提示')" v-if="fieldval.buttonNotips == '1'">
          <img class="hintImg" src="https://imagecdn.ymm56.com/ymmfile/static/resource/79787d2b-21f5-45c0-ae79-be3d7fcbddd8.png" alt="" />
          不再提示
        </div>
        <div class="popupDefinitionContent" :style="bottomPopup ? 'height: calc(100% - 92px)' : 'height: calc(100% - 46px)'">
          <img
            v-if="configurationData.imgtype === '0'"
            @click="postSkip()"
            style="cursor: pointer"
            class="popupDefinitionContentImg"
            :src="configurationData.imgpath"
            alt=""
          />
          <iframe
            v-if="configurationData.imgtype === '1'"
            class="popupDefinitionContentImg"
            :src="configurationData.imgpath"
            frameborder="0"
          ></iframe>
        </div>
        <div class="popupDefinitionDottom" v-if="bottomPopup">
          <div class="popupDefinitionDottomSecond" v-if="fieldval.durationIf == '1'">
            <span style="color: red">{{ countdown }}</span>
            秒后自动为您确定
          </div>
          <div
            class="popupDefinitionDottomMiddle"
            v-if="configurationData.isshowprotocol == 1"
            :style="fieldval.durationIf != '1' ? 'margin-left: 20px' : ''"
          >
            <input type="checkbox" class="TMS-checkbox" style="cursor: pointer; margin-right: 5px" id="showFilter" v-model="agreement" />
            <label class="TMS-label" style="width: auto; cursor: pointer" for="showFilter">我已阅读并同意以下协议</label>
            <span class="popupDefinitionDottomMiddle" v-for="(item, index) in protocolpath" :key="index">
              <a style="text-decoration: none" :href="item.AttachmentUrl" target="_blank" download="download">
                《{{ configurationData.protocoltitle }}》
              </a>
            </span>
            <!-- 我已阅读并同意以下协议 《123协议》  -->
          </div>
          <div class="popupDefinitionDottomDutton">
            <div class="DuttonStyle" @click="affirm(0)" v-if="fieldval.buttonCofirm">确认</div>
            <div
              v-if="fieldval.buttonCancel"
              class="DuttonStyle"
              @click="getClose('取消')"
              style="margin-right: 20px; margin-left: 20px; border: 1px solid #dcdfe6; background: #fff; color: #606266"
            >
              取消
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popupDefinitionFreeMessage yy" v-if="guidePageShwo">
      <div class="maskWin"></div>
      <div
        class="popupDefinitionAll"
        :style="{
          width: guidance.width + '%',
          height: guidance.height + '%',
          animation: voluntarilyClose ? 'slideToCornerHide 2s ease forwards' : ''
        }"
      >
        <!-- <div class="popupDefinitionHeadline">
                <div style="padding-left:20px"></div>
                <div @click="getClose('关闭')"  style="cursor: pointer;"><img  class="popupDefinitionHeadlineClosebannerImg" src="https://imagecdn.ymm56.com/ymmfile/static/resource/79787d2b-21f5-45c0-ae79-be3d7fcbddd8.png" alt=""></div>
              </div> -->
        <div class="perpetualCloseGuidePageShwo" v-if="guidance.close" @click="guidePageClose" style="right: 17px; top: 11px">
          <img class="hintImg" style="width: 25px; height: 25px" src="https://imagecdn.ymm56.com/ymmfile/static/resource/79787d2b-21f5-45c0-ae79-be3d7fcbddd8.png" alt="" />
        </div>
        <div class="popupDefinitionContent" :style="'height: calc(100%)'">
          <img @click="guidePagePostSkip()" style="cursor: pointer" class="popupDefinitionContentImg" :src="guidance.imgpath" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'popupDefinitionComponent',
  props: {
    hasNewWXServiceAd: {
      default: false
    }
  },
  data() {
    return {
      popupShow: false,
      popupIndex: false,
      guidePageShwo: false,
      popupSecond: 15,
      agreement: true,
      countdown: '',
      baseUrl:
        window.location.host == 't9bs.lqfast.com' || window.location.host == 't9bsjcqa.lqfast.com'
          ? 'https://internal-marketing.lqfast.com'
          : 'https://internal-marketing-dev.lqfast.com',
      configurationData: {},
      protocolpath: [], //协议
      fieldval: {
        name: '', //名称
        height: 50, //高度百分比
        width: 50, //长度百分比
        buttonClose: '', //关闭按钮 右上角X
        buttonCofirm: '', //确定按钮","
        buttonCancel: '', //取消按钮
        buttonNotips: '', //不再提示按钮
        durationIf: '', //是否开启开启读秒
        seconds: '', //读秒秒数
        projectid: '', //来源id
        confirmType: 0 // 0关闭 1跳转
      },
      guidance: {
        height: 50, //高度百分比
        width: 50, //长度百分比
        imgpath: '',
        showtime: 3,
        voluntarilyClose: 3,
        close: 0
      },
      guidePageObj: {},
      groupname: '',
      bottomPopup: true, //显示底部
      countDownTimer: null, //倒计时
      dataList: [],
      getuserinfo: getNewUserInfo(),
      voluntarilyClose: false,
      findList: [],
      TimeoutguidePage: null //引导页的定时器
    }
  },
  mounted() {
    window.addEventListener('message', event => {
      // if (event.origin !== "http://localhost:9528") return; // 确保消息来源可靠
      if (['https://wx.lqfast.com', 'https://wx-dev.lqfast.com', 'http://localhost:9528'].indexOf(event.origin) == -1) return // 确保消息来源可靠
      // console.log("Received message:", event);
      // frameElement.dialog.hide();
      // this.handleResize()
      this.popupShow = false
    })
    $.ajax({
      url: this.baseUrl + '/api/AdvertApi/GetOpenProject',
      data: {},
      method: 'post',
      beforeSend: function (request) {
        request.setRequestHeader('source', 'T9BS')
      },
      success: res => {
        if (res.Success) {
          let data
          try {
            data = JSON.parse(res.data) || []
          } catch (error) {
            data = []
          }
          this.dataList = data
          this.findList = []
          for (let index = 0; index < data.length; index++) {
            const element = data[index]
            this.findList.push(element.projectid)
            if (element.region == '引导页') {
              this.guidePageObj = element
              this.guidance.imgpath = element.imgpath
              let fieldvaljson = JSON.parse(this.guidePageObj.fieldvaljson)
              for (let index = 0; index < fieldvaljson.length; index++) {
                const element = fieldvaljson[index]
                if (element.field == 'voluntarilyClose') {
                  this.guidance.showtime = element.seconds || 3 //时间
                  this.guidance.voluntarilyClose = element.value //时间
                }
                if (element.field == 'height') {
                  this.guidance.height = element.value //高度百分比
                }
                if (element.field == 'width') {
                  this.guidance.width = element.value //长度百分比
                }
                if (element.field == 'close') {
                  this.guidance.close = element.value //长度百分比
                }
              }
            }
            if (element.region == '弹窗') {
              this.configurationData = element
              this.projectid = this.configurationData.projectid || ''
              if (
                this.configurationData.imgpath.indexOf('https://wx.lqfast.com/wx/PublicH5page/#/') != -1 ||
                this.configurationData.imgpath.indexOf('https://wx-dev.lqfast.com/wx/PublicH5page/#/') != -1
              ) {
                let marketingEnvironment = 'dev'
                if (window.location.host == 't9bs.lqfast.com') {
                  marketingEnvironment = 'prod'
                } else if (window.location.host == 't9bsjcqa.lqfast.com') {
                  marketingEnvironment = 'T9BSqa'
                } else {
                  marketingEnvironment = 'dev'
                }
                this.configurationData.imgpath = `${this.configurationData.imgpath}?marketingUserId=${this.getuserinfo.UserId}&marketingSourcee=T9BS&marketingToken=${this.getuserinfo.Token}
                                   &marketingTenantcode=${this.getuserinfo.TMSCode}&marketingEnvironment=${marketingEnvironment}`
              }
              this.groupname = this.configurationData.project
              this.protocolpath = JSON.parse(this.configurationData.protocolpath)
              let fieldvaljson = JSON.parse(this.configurationData.fieldvaljson)
              // console.log(fieldvaljson,"3333333333")
              for (let index = 0; index < fieldvaljson.length; index++) {
                const element = fieldvaljson[index]
                if (element.field == 'name') {
                  this.fieldval.name = element.value + '-' + $.getcookie('tmsbstmscode') //名称
                }
                if (element.field == 'height') {
                  this.fieldval.height = element.value //高度百分比
                }
                if (element.field == 'width') {
                  this.fieldval.width = element.value //长度百分比
                }
                if (element.field == 'close') {
                  this.fieldval.buttonClose = element.value //关闭按钮 右上角X
                }
                if (element.field == 'confirm') {
                  this.fieldval.buttonCofirm = element.value //确定按钮","
                  this.fieldval.confirmType = element.confirmType //确定按钮是否跳转","
                }
                if (element.field == 'cancel') {
                  this.fieldval.buttonCancel = element.value //取消按钮
                }
                if (element.field == 'nohint') {
                  this.fieldval.buttonNotips = element.value //不在提醒
                }
                if (element.field == 'passParameter') {
                  this.fieldval.passParameter = element.value //不在提醒
                }
                if (element.field == 'duration') {
                  this.fieldval.durationIf = element.value //是否开启
                  this.fieldval.seconds = element.seconds //读秒秒数
                  this.popupSecond = element.seconds || 15
                }
              }
              if (
                this.fieldval.durationIf != 1 &&
                this.fieldval.buttonCofirm != 1 &&
                this.fieldval.buttonCancel != 1 &&
                this.configurationData.isshowprotocol != 1
              ) {
                this.bottomPopup = false
              }
            }
          }
          this.getpopupShow()
        }
      }
    })
  },
  watch: {
    popupShow(item) {
      //关闭弹窗 要把定时器清除了,避免重复调用
      if (!item) {
        clearInterval(this.countDownTimer)
      }
    },
    agreement(item) {
      //关闭弹窗 要把定时器清除了,避免重复调用
      if (!item) {
        clearInterval(this.countDownTimer)
      } else {
        this.startCountdown()
      }
    }
  },
  methods: {
    guidePagePostSkip() {
      this.getSaveBurypoint(this.guidePageObj.project, this.guidePageObj.projectid, '点击跳转')
      let verifyFinish = this.guidePageObj.verifyFinish.split(',')
      let getNewUserIn = getNewUserInfo()
      let openurl = this.guidePageObj.openurl
      let prefix = '&'
      if (openurl.indexOf('?') == -1) {
        prefix = '?'
      }
      for (let index = 0; index < verifyFinish.length; index++) {
        let element = verifyFinish[index]
        if (index == 0) {
          openurl += prefix
        } else {
          openurl += '&'
        }
        if (element == 'companyid') {
          openurl += 'companyid=' + encodeURIComponent(this.guidePageObj.companyid)
        } else {
          openurl += element + '=' + getNewUserIn[element]
        }
      }
      if (verifyFinish.length != 0) {
        openurl += '&Token=' + getNewUserIn.Token + '&source=' + 'T9BS'
      } else {
        openurl += prefix + 'Token=' + getNewUserIn.Token + '&source=' + 'T9BS'
      }
      if (this.guidePageObj.opentype != 0) {
        window.open(openurl)
      }
    },
    guidePageClose() {
      // setTimeout(() => {
      clearTimeout(this.TimeoutguidePage)
      this.voluntarilyClose = true
      setTimeout(() => {
        this.getSaveBurypoint(this.guidePageObj.project, this.guidePageObj.projectid, '关闭')
        this.voluntarilyClose = false
        this.guidePageShwo = false
      }, 2000) // 每隔1秒执行一次

      //  }, this.guidance.showtime*1000); // 每隔1秒执行一次
    },
    affirm(item) {
      //确认
      if (!this.agreement) {
        showMsg({ content: '请勾选协议', time: 3000 })
        return
      }
      if (item != 1) {
        this.getSaveBurypoint(this.groupname, this.projectid, '确认')
      }
      if (item == 0 && this.fieldval.confirmType != 1) {
        this.popupShow = false
        return
      }
      this.postSkip()
    },
    getClose(point) {
      this.popupShow = false
      this.getSaveBurypoint(this.groupname, this.projectid, point)
    },
    getpopupShow() {
      let list = this.dataList
      let projectList = []
      for (let index = 0; index < list.length; index++) {
        const element = list[index]
        let obj = {
          project: element.project,
          projectid: element.projectid
        }
        projectList.push(obj)
      }
      $.ajax({
        url: this.baseUrl + `/api/AdvertApi/VerfyOpenProject?project=1&projectid=1&projectList=${JSON.stringify(projectList)}`,
        data: {},
        method: 'post',
        beforeSend: function (request) {
          request.setRequestHeader('source', 'T9BS')
        },
        success: res => {
          if (res.Success) {
            let executePopup = 0
            let guidePagePopup = 0
            let list = res.data || []
            for (let index = 0; index < list.length; index++) {
              const element = list[index]
              if (this.findList.indexOf(element.projectid) !== -1) {
                this.dataList[this.findList.indexOf(element.projectid)].ifShow = element.isopen
              }
            }
            function sortBank(a, b) {
              return a.openlever - b.openlever
            }
            this.dataList.sort(sortBank)
            let dataList = this.dataList
            for (let index = 0; index < dataList.length; index++) {
              const element = dataList[index]
              if (element.ifShow) {
                if (element.region == '公告按钮') {
                  this.$emit('noticeButtons', element)
                }
                // 优先级判断，如果外层有弹框，就不弹了
                if (element.region == '引导页' && !this.hasNewWXServiceAd) {
                  this.guidePageShwo = true
                  if (this.guidance.voluntarilyClose) {
                    guidePagePopup = index + 1
                  }
                }
                // 优先级判断，如果外层有弹框，就不弹了
                if (element.region == '弹窗' && !this.hasNewWXServiceAd) {
                  this.popupShow = true
                  this.getSaveBurypoint(this.groupname, this.configurationData.projectid, '弹出')
                  executePopup = index + 1
                }
              }
            }
            if (executePopup != 0) {
              this.startCountdown() // 在组件加载完成后开始倒计时
            }
            if (executePopup > guidePagePopup) {
              this.popupIndex = true
            }
            if (guidePagePopup != 0) {
              this.TimeoutguidePage = setTimeout(() => {
                this.voluntarilyClose = true
                setTimeout(() => {
                  this.getSaveBurypoint(this.guidePageObj.project, this.guidePageObj.projectid, '自动关闭')
                  this.voluntarilyClose = false
                  this.guidePageShwo = false
                }, 2000) // 每隔1秒执行一次
              }, (this.guidance.showtime || 3) * 1000) // 每隔1秒执行一次
            }
          }
        }
      })
    },

    getSaveBurypoint(project, projectid, point) {
      $.ajax({
        url: this.baseUrl + `/api/AdvertApi/SaveBurypoint?project=${project}&projectid=${projectid}&point=${point}`,
        data: {},
        method: 'post',
        beforeSend: function (request) {
          request.setRequestHeader('source', 'T9BS')
        },
        success: function (res) {},
        complete: function () {}
      })
    },
    strUrlObj(url) {
      // 去除第一个？
      var string = url
      string = string.slice(1)
      // 去掉字符串中的 & 的数组
      var strArray = string.split('&')
      // console.log(strArray)  //["id=1", "name=fqniu", "age=25", "workName=frontEnd"]
      // 定义一个空对象
      var obj = {}
      for (var i = 0; i < strArray.length; i++) {
        // 定义一个新的数组来接收 去掉字符串中的 = 的数组
        var newArray = strArray[i].split('=')
        // console.log(newArray)
        // 然后遍历添加每个数组中对应的数据 添加到对象中
        obj[newArray[0]] = newArray[1]
      }
      return obj
    },
    postSkip() {
      //跳转
      if (this.configurationData.isopen == '1' && this.agreement) {
        if (this.configurationData.opentype == 2) {
          let openurl = this.configurationData.openurl
          let arr = openurl.split('?')
          let parameter1 = this.strUrlObj('?' + arr[1])
          $.ligerDialog.open({
            title: parameter1.title + '-' + $.getcookie('tmsbstmscode'),
            url: getEVNUrlByWhitelist(arr[0]),
            _type: 'add',
            isNew: true,
            width: parameter1.width,
            height: parameter1.height
          })
          this.popupShow = false
          clearInterval(this.countDownTimer)
          return
        }
        let verifyFinish = this.configurationData.verifyFinish.split(',')
        let getNewUserIn = getNewUserInfo()
        let openurl = this.configurationData.openurl
        let prefix = '&'
        if (openurl.indexOf('?') == -1) {
          prefix = '?'
        }
        for (let index = 0; index < verifyFinish.length; index++) {
          let element = verifyFinish[index]
          if (index == 0) {
            openurl += prefix
          } else {
            openurl += '&'
          }
          if (element == 'companyid') {
            openurl += 'companyid=' + encodeURIComponent(this.configurationData.companyid)
          } else {
            openurl += element + '=' + getNewUserIn[element]
          }
        }
        if (verifyFinish.length != 0) {
          openurl += '&Token=' + getNewUserIn.Token + '&source=' + 'T9BS'
        } else {
          openurl += prefix + 'Token=' + getNewUserIn.Token + '&source=' + 'T9BS'
        }

        clearInterval(this.countDownTimer)
        this.fieldval.durationIf = 0
        if (this.configurationData.opentype == 0) {
          this.configurationData.imgtype = '1'
          this.configurationData.imgpath = openurl
          // this.configurationData.imgpath ='https://lqms.lqfast.com/#/'
        } else if (this.configurationData.opentype == 1) {
          try {
            if (this.fieldval.passParameter == 1) {
              window.open(openurl)
            } else {
              window.open(this.configurationData.openurl)
            }
          } catch (error) {
            window.open(openurl)
          }
        }
        // else if(this.configurationData.opentype==2){
        //   // let arr = str.split(" ");

        //   console.log(openurl,"222222222")
        //   $.ligerDialog.open({
        //                     title:'短信快速自助充值-'+$.getcookie("tmsbstmscode"),
        //                     url: getEVNUrlByWhitelist('/AcceptanceOfBill/SMSRecharge'),
        //                     _type: "add",
        //                     isNew: true,
        //                     width: 770,
        //                     height: 610
        //     });
        // }
      }
    },
    startCountdown() {
      //倒计时
      if (this.fieldval.durationIf != 1) {
        return
      }
      this.countDownTimer = setInterval(() => {
        if (this.popupSecond > 0) {
          this.countdown = `${this.popupSecond}` // 更新显示的倒计时文本
          this.popupSecond-- // 每次递减1秒
        } else {
          clearInterval(this.countDownTimer) // 当倒计时结束时清除定时器
          this.affirm(1)
          // console.log("55555555555")
          this.getSaveBurypoint(this.groupname, this.configurationData.projectid, '倒计时结束')
          this.fieldval.durationIf = 0
          this.countdown = '0' // 可选：将倒计时文本重置为特定内容
        }
      }, 1000) // 每隔1秒执行一次
    }
  }
}
</script>
<style>
@keyframes slideToCornerHide {
  100% {
    width: 102px;
    height: 33px;
    left: 499px;
    top: 29px;
    opacity: 0;
  }
  90% {
    opacity: 0.5;
  }
  80% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
}
.popupDefinitionFreeMessage {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 99998;
  /* background-color: #ffffff; */
}
.perpetualClose {
  position: absolute;
  top: 55px;
  left: 19px;
  display: flex;
  align-items: center;
  color: #aba0aa;
  cursor: pointer;
}
.perpetualCloseGuidePageShwo {
  position: absolute;
  top: 11px;
  right: 17px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #aba0aa;
  cursor: pointer;
}
.hintImg {
  width: 16px;
  height: 16px;
}
.popupDefinitionAll {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 8px;
}
.popupDefinitionHeadline {
  display: flex;
  justify-content: space-between;
  height: 46px;
  align-items: center;
  font-size: 15px;
  font-weight: bold;
}
.popupDefinitionHeadlineClosebannerImg {
  padding-right: 20px;
  width: 20px;
  height: 20px;
  z-index: 99998;
}
.popupDefinitionContent {
  width: 100%;
  height: calc(100% - 92px);
}
.popupDefinitionContentImg {
  width: 100%;
  /* height: calc(100% - 92px); */
  height: 100%;
}
.popupDefinitionDottom {
  width: 100%;
  height: 46px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popupDefinitionDottomDutton {
  display: flex;
}
.DuttonStyle {
  width: 72px;
  height: 35px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #409eff;
  border-radius: 4px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
}
.popupDefinitionDottomSecond {
  padding-left: 20px;
  font-size: 15px;
}
.popupDefinitionDottomMiddle {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.popupDefinitionFreeMessage .maskWin {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
</style>
